import React, { useState } from 'react';
import { Form, Input, Button, Card, Typography, message, Row, Col, Divider } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate, Link, useSearchParams, useLocation } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import { authAPI } from '../services/api';

const { Title, Text } = Typography;

const Login: React.FC = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const { setAuth } = useAuthStore();

  const rawRedirect =
    searchParams.get('redirect') ||
    (location.state as { from?: string } | null)?.from ||
    '/app';
  // Prevent open redirect: only same-origin relative paths
  const redirectTo =
    typeof rawRedirect === 'string' &&
    rawRedirect.startsWith('/') &&
    !rawRedirect.startsWith('//') &&
    !rawRedirect.includes('\\')
      ? rawRedirect
      : '/app';

  const onFinish = async (values: { username: string; password: string }) => {
    setLoading(true);
    try {
      const data = await authAPI.login(values.username, values.password);
      setAuth(data.user, data.token);
      message.success('Вход выполнен успешно!');
      navigate(redirectTo.startsWith('/') ? redirectTo : '/app', { replace: true });
    } catch (error: any) {
      message.error(error.response?.data?.error || 'Ошибка входа');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#f0f2f5',
      padding: '20px'
    }}>
      <Row justify="center" style={{ width: '100%' }}>
        <Col xs={22} sm={16} md={12} lg={8} xl={6}>
          <Card
            style={{
              boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
              borderRadius: '8px'
            }}
            variant="outlined"
          >
            <div style={{ textAlign: 'center', marginBottom: '28px' }}>
              <Text type="secondary" style={{ fontSize: '18px', marginBottom: '8px', display: 'block', fontWeight: 'bold' }}>
                Обеды для сотрудников
              </Text>
              <Title level={2} style={{ margin: 0, color: '#FF6B35' }}>
                🍽️ Luemen
              </Title>
              <Text type="secondary" style={{ fontSize: '12px', marginTop: '8px', display: 'block', lineHeight: '1.4', maxWidth: '300px', margin: '8px auto 0' }}>
                мы делаем так, чтобы предпринимателям было легко организовывать обеды для сотрудников
              </Text>
            </div>

            <Form
              form={form}
              name="login"
              onFinish={onFinish}
              autoComplete="off"
              size="large"
            >
              <Form.Item
                name="username"
                rules={[{ required: true, message: 'Введите имя пользователя!' }]}
              >
                <Input
                  prefix={<UserOutlined />}
                  placeholder="Имя пользователя"
                  autoComplete="off"
                />
              </Form.Item>

              <Form.Item
                name="password"
                rules={[{ required: true, message: 'Введите пароль!' }]}
              >
                <Input.Password
                  prefix={<LockOutlined />}
                  placeholder="Пароль"
                />
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={loading}
                  style={{ width: '100%', height: '36px' }}
                >
                  Войти
                </Button>
              </Form.Item>
            </Form>

            <Divider style={{ margin: '20px 0' }} />

            <div style={{ textAlign: 'center' }}>
              <div style={{ marginBottom: '12px' }}>
                <Text type="secondary">
                  Нет аккаунта?{' '}
                  <Link to="/register" style={{ color: '#1890ff', fontWeight: 500 }}>
                    Зарегистрироваться
                  </Link>
                </Text>
              </div>
              <div>
                <Text type="secondary">
                  <Link to="/forgot-credentials" style={{ color: '#1890ff', fontWeight: 500 }}>
                    Забыли пароль или имя пользователя?
                  </Link>
                </Text>
              </div>
            </div>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Login;

